import { createComposite } from '@opengov/component-library-classic/module/composites';
import { createModalCompositeMap } from '@opengov/component-library-classic/module/modals/compositeProcessor';

import { ReportExportDialog } from '../../../reportExplorer/ReportExportDialog/ReportExportDialog';
import { ReportDeletingDialog } from '../../../reportSettings/ReportDeletingDialog/ReportDeletingDialog';
import { ColorControlsModal } from '../components/ColorControlsModal/ColorControlsModal';
import { ColumnSettingsModal } from '../components/ColumnSettingsModal/ColumnSettingsModal';
import { CopyReportModal } from '../components/CopyReportModal/CopyReportModal';
import { CreateBasicCalculationModal } from '../components/CreateBasicCalculationModal/CreateBasicCalculationModal';
import { CreateCalculationModal } from '../components/CreateCalculationModal/CreateCalculationModal';
import { EnhancedCreateConditionalModal as CreateConditionalModal } from '../components/CreateConditionalModal/CreateConditionalModal';
import { EditControlBlockModal } from '../components/EditControlBlockModal/EditColumnControlBlockModal';
import { ReportCreatingModal } from '../components/ReportCreatingModal/ReportCreatingModal';
import { ReportCreatingModalMui } from '../components/ReportCreatingModal/ReportCreatingModalMui';
import { SavedViewCreatingModal } from '../components/SavedViewCreatingModal/SavedViewCreatingModal';
import { SavedViewDeletingDialog } from '../components/SavedViewDeletingDialog/SavedViewDeletingDialog';
import { SetTargetModal } from '../components/SetTargetModal/SetTargetModal';
import { StandardTemplateModal } from '../components/StandardTemplateModal/StandardTemplateModal';
import {
  selectColorControlsModalState,
  selectColumnSettingsModalState,
  selectControlBlockModalState,
  selectCopyReportModalState,
  selectCreateBasicCalculationModalState,
  selectCreateCalculationModalState,
  selectCreateConditionalModalState,
  selectManageModalState,
  selectReportCreatingModalState,
  selectReportDeletingModalState,
  selectReportExportModalState,
  selectSavedViewCreatingModalState,
  selectSavedViewDeletingModalState,
  selectSetTargetModalState,
  selectShareModalState,
  selectStandardTemplateModalState
} from '../selectors/modalSelectors';

import { DimensionalSavedViewCreatingModal } from '../components/DimensionalSavedViewCreatingModal/DimensionalSavedViewCreatingModal';
import { ShareModal } from '../components/ShareModal/ShareModal';

import { ManageAccessModal } from '../components/ManageAccessModal/ManageAccessModal';
import { ManageAccountSummaryAccessModal } from '../components/ManageAccessModal/ManageAccountSummaryAccessModal';
import { ReportModalTypes } from '../types/modalTypes';
import { ChartAndDetailsCopyReportModal } from '../components/CopyReportModal/ChartAndDetailsCopyReportModal';
import { ChartAndDetailsReportDeletingDialog } from '../../../reportSettings/ReportDeletingDialog/ChartAndDetailsReportDeletingDialog';

const compositeFunctions = createModalCompositeMap({
  [ReportModalTypes.REPORT_CREATING]: createComposite(ReportCreatingModal, selectReportCreatingModalState),
  [ReportModalTypes.REPORT_CREATING_MDS]: createComposite(ReportCreatingModalMui, selectReportCreatingModalState),
  [ReportModalTypes.REPORT_DELETING]: createComposite(ReportDeletingDialog, selectReportDeletingModalState),
  [ReportModalTypes.CD_REPORT_DELETING]: createComposite(
    ChartAndDetailsReportDeletingDialog,
    selectReportDeletingModalState
  ),
  [ReportModalTypes.REPORT_EXPORT]: createComposite(ReportExportDialog, selectReportExportModalState),
  [ReportModalTypes.COLUMN_EDIT]: createComposite(ColumnSettingsModal, selectColumnSettingsModalState),
  [ReportModalTypes.CREATE_CALCULATION]: createComposite(CreateCalculationModal, selectCreateCalculationModalState),
  [ReportModalTypes.CREATE_BASIC_CALCULATION]: createComposite(
    CreateBasicCalculationModal,
    selectCreateBasicCalculationModalState
  ),
  [ReportModalTypes.CREATE_CONDITIONAL]: createComposite(CreateConditionalModal, selectCreateConditionalModalState),
  [ReportModalTypes.SAVED_VIEW_CREATING]: createComposite(SavedViewCreatingModal, selectSavedViewCreatingModalState),
  [ReportModalTypes.DIMENSIONAL_SAVED_VIEW_CREATING]: createComposite(
    DimensionalSavedViewCreatingModal,
    selectSavedViewCreatingModalState
  ),
  [ReportModalTypes.SAVED_VIEW_DELETING]: createComposite(SavedViewDeletingDialog, selectSavedViewDeletingModalState),
  [ReportModalTypes.COLOR_CONTROLS]: createComposite(ColorControlsModal, selectColorControlsModalState),
  [ReportModalTypes.SET_TARGET]: createComposite(SetTargetModal, selectSetTargetModalState),
  [ReportModalTypes.REPORT_SHARE]: createComposite(ShareModal, selectShareModalState),
  [ReportModalTypes.MANAGE_ACCESS]: createComposite(ManageAccountSummaryAccessModal, selectManageModalState),
  [ReportModalTypes.MANAGE_ACCESS_CD]: createComposite(ManageAccessModal, selectManageModalState),
  [ReportModalTypes.TEMPLATIZE]: createComposite(StandardTemplateModal, selectStandardTemplateModalState),
  [ReportModalTypes.COPY_REPORT]: createComposite(CopyReportModal, selectCopyReportModalState),
  [ReportModalTypes.CD_COPY_REPORT]: createComposite(ChartAndDetailsCopyReportModal, selectCopyReportModalState),
  [ReportModalTypes.EDIT_CONTROL_BLOCK]: createComposite(EditControlBlockModal, selectControlBlockModalState)
});

export const { component: getModalComponent, selector: getModalSelector } = compositeFunctions;
